import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "titleId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { createElement } from 'react';
import { CreateSVG } from "../lib/index.js";
function SvgIconHamburger(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/createElement(CreateSVG, _objectSpread(_objectSpread({}, props), {}, {
    renderIcon: function renderIcon(props) {
      return /*#__PURE__*/React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        viewBox: "0 0 52 52",
        xmlSpace: "preserve",
        enableBackground: "new 0 0 52 52",
        "aria-labelledby": titleId
      }, props), title ? /*#__PURE__*/React.createElement("title", {
        id: titleId
      }, title) : null, /*#__PURE__*/React.createElement("style", {
        type: "text/css"
      }, '.Icon-hamburger_svg__st0{display:none}.Icon-hamburger_svg__st1{display:inline}.Icon-hamburger_svg__st2{fill:none}'), /*#__PURE__*/React.createElement("g", {
        id: "Icon-hamburger_svg__stroke"
      }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
        d: "M46,25H6c-0.5522,0-1,0.4473-1,1s0.4478,1,1,1h40c0.5522,0,1-0.4473,1-1S46.5522,25,46,25z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M46,10.8828H6c-0.5522,0-1,0.4473-1,1s0.4478,1,1,1h40c0.5522,0,1-0.4473,1-1S46.5522,10.8828,46,10.8828z"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M46,39.1172H6c-0.5522,0-1,0.4473-1,1s0.4478,1,1,1h40c0.5522,0,1-0.4473,1-1S46.5522,39.1172,46,39.1172z"
      }))), /*#__PURE__*/React.createElement("g", {
        id: "Icon-hamburger_svg__filled",
        className: "Icon-hamburger_svg__st0"
      }));
    }
  }));
}
export default SvgIconHamburger;